module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-wrapper"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('DOCTOR_CONSULTATIONS')) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ANOTHER_CONSULTATION')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('WE_HAVE_PREPARED')))]), _vm._v(" "), _c('div', {
    staticClass: "row mt-4 mb-4"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('GmapAutocomplete', {
    staticClass: "text-input",
    attrs: {
      "placeholder": _vm.$t('INSERT_LOCALIZATION')
    },
    on: {
      "place_changed": _vm.setPlace
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('gmap-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "550px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom,
      "options": {
        styles: _vm.mapStyles
      }
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "options": {
          styles: _vm.mapStyles
        },
        "clickable": true,
        "map-type-id": "satellite",
        "icon": _vm.icon
      },
      on: {
        "click": function($event) {
          return _vm.show(m)
        }
      }
    }, [(m.showInfoWindow) ? _c('gmap-info-window', {
      on: {
        "closeclick": function($event) {
          return _vm.show(m)
        }
      }
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(m.info.name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(m.info.addres.street))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(m.info.addres.postcode) + ", " + _vm._s(m.info.addres.city))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(m.info.phone1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(m.info.phone2))]), _vm._v(" "), _c('a', {
      staticClass: "arrow-link mt-3",
      attrs: {
        "href": "https://www.google.pl/maps/place/" +
          m.info.addres.street +
          "-" +
          m.info.addres.postcode +
          "-" +
          m.info.addres.city,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('SEE_IN_GOOGLE_MAPS')) + " "), _c('img', {
      attrs: {
        "src": require("./../../../assets/images/arrow-red.png")
      }
    })])]) : _vm._e()], 1)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6ab635","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/google-maps/maps.vue
// module id = 1170
// module chunks = 0